module.exports = __webpack_public_path__ + "img/fail.c5ce514f.png";